require("turbolinks").start()
require('trix')

import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel';
import MicroModal from 'micromodal';

$(document).on('ready turbolinks:load', function () {
    var owl = $('.owl-carousel').owlCarousel({
        loop: false,
        margin: 0,
        nav: true,
        items: 1,
        animationOut: true,
        animateOut: 'fadeOut',
        animateIn: 'fadeIn',
        dots: true,
        dotsContainer: ".owl-dots",
        URLhashListener: true,
        startPosition: 'URLHash',
        navText: [' ', ' '],
    })

    $('.owl-dots').on('click', 'li', function (e) {
        owl.trigger('to.owl.carousel', [$(this).index(), 300]);
    });

    var activeDot = $('.owl-dots').find('.active')

    $('owl-dot').removeClass('.active')

    if (activeDot.hasClass('subchapter')) {
        var previousDot = $(activeDot).prev()
        while (!previousDot.hasClass('chapter')) {
            previousDot = previousDot.prev()
        }
        previousDot.addClass('active');
    }


    owl.on('changed.owl.carousel', function (e) {
        var activeDot = $('.owl-dots').find('.active')

        $('owl-dot').removeClass('.active')

        if (activeDot.hasClass('subchapter')) {
            var previousDot = $(activeDot).prev()
            while (!previousDot.hasClass('chapter')) {
                previousDot = previousDot.prev()
            }
            previousDot.addClass('active');
        }
    });

    /*
        MicroModal.init({
            onShow: modal => console.info(`${modal.id} is shown`), // [1]
            onClose: modal => console.info(`${modal.id} is hidden`), // [2]
            openTrigger: 'data-custom-open', // [3]
            closeTrigger: 'data-custom-close', // [4]
            disableScroll: true, // [5]
            disableFocus: false, // [6]
            awaitCloseAnimation: false, // [7]
            debugMode: true // [8]
        });
    
        var buttons = $('.modalTrigger');
    
        buttons.click( function(){
            console.log($(this))
            $("#modal-1-content").empty()
            $("#modal-1-content").prepend($(this).html())
            MicroModal.show('modal-1');
        });
    */
    // function onShow(modal){
    //   if($(modal).attr("data-target")){
    //     console.log('${modal.id} has target' + $(modal).attr("data-target"));
    //     //$(modal).find('.modal__content').load($(modal).attr("data-target"));
    //   }
    //
    // }
    MicroModal.init({
        onShow: modal => onShow(modal),
        onClose: modal => onClose(modal)
    });

    function onShow(modal) {
        if (!$(modal).hasClass("valid") && $(modal).hasClass("micromodal-item")) {
            $.ajax({
                url: "/viewer/" + modal.id.substr(6, 8),
                type: "GET",
                complete: function (response, status) {
                    $(modal).children().children().append(response.responseText);
                }
            });
        }
    };

    function onClose(modal) {
        $(modal).addClass("valid")
    }

    $(".modal-item-trigger").click(function () {
        $(".uv").attr("data-uri", $(this).attr("uri-target"))
        $(".uv").find("#easyXDM_default4769_provider").attr("src", $(this).attr("src-target"))
        initPlayers($('.uv').not('[data-no-load*=true]'))
    })

    $(".control-plus").click(function () {
        $(this).fadeOut(function () {
            $(this).next().fadeIn()
        })
        $(this).parent().parent().prev().fadeIn("slow");
    });

    $(".control-minus").click(function () {
        $(this).fadeOut(function () {
            $(this).prev().fadeIn()
        })
        $(this).parent().parent().prev().fadeOut("slow");
    });

    $('.image-overlay')
        .mouseenter(function () {
            $(this).next().fadeIn()
        })
        .mouseleave(function () {
            $(this).next().fadeOut()
        });

    $('.nav').click(function () {
        window.location = "https://www.armarium-hautsdefrance.fr/exhibits";
    });

    $('.socialNetworkTrigger').click(function () {
        if ($('.socialNetwork-animation-container').css('display') == 'block') {
            $('.socialNetwork-animation-container').fadeOut();
        } else {
            $('.socialNetwork-animation-container').fadeIn();
        }

    })

    $('a').each(function () {

        if (this.host !== window.location.host) {
            this.setAttribute("target", "_blank")
        }
    })

    $('.attachment__name').children().each(function () {
        this.setAttribute('target', '_blank')
    })

    // screen.lockOrientation('landscape');

    jQuery(document.documentElement).keyup(function (event) {
        if (event.keyCode == 37) {
            owl.trigger('prev.owl');
        } else if (event.keyCode == 39) {
            owl.trigger('next.owl');
        }

    });

});
